import React from 'react';
import classNames from '../../utils/classnameUtils'
import 'lazysizes';

export const LOADING_IMG = {
    LAZY: 'lazy',
    EAGER: 'eager'
}

const Imgcomponent = ({
    className = '',
    src,
    crop = null,
    size = null,
    alt = '',
    style = {},
    loading = LOADING_IMG.LAZY,
    setimagebool,
    ...imgSet
}) => {
    const [ srcState, setSrcState] = React.useState((null));
    const [imageError, setImageError] = React.useState((false));
    const [imageLoad, setImageLoad] = React.useState(false);
    const loadingBoolResult = (!!('loading' in HTMLImageElement.prototype));

    const functionError = () => {
        setImageError(true)
        if (typeof setimagebool === 'function') {
            setimagebool(false)
        }
    }

    const functionLoad = () => {
        setImageLoad(true)
        if (typeof setimagebool === 'function') {
            setimagebool(true)
        }
    }

    React.useEffect(() => {
        if (!src) {
            functionError();
        }else{ 
            if(imageError===true){
                setImageLoad(false)
            } 
            if(typeof crop === 'string' && typeof size === 'string'){
                setSrcState(`${src}?crop=${crop}&size=${size}`);
            }else if(typeof size === 'string'){
                setSrcState(`${src}?size=${size}`);
            }else{
                setSrcState(src);
            }
            if(imageError===true){
                setImageError(false)
            } 
        }
    }, [src])

    return (<React.Fragment>
        {!imageError && !!srcState && <img
            alt={alt ?? 'Imgcomponent'}
            {...imgSet}
            className={classNames(className, loadingBoolResult ? '' : 'lazyload')}
            src={loadingBoolResult ? srcState : null}
            data-src={loadingBoolResult ? null : srcState}
            onError={functionError}
            onLoad={functionLoad}
            loading={loading}
            style={!imageLoad ? {
                visibility: 'hidden',
                opacity: 0,
                transition: 'visibility 0s, opacity 0.2s linear',
                ...style
            } : {
                visibility: 'visible',
                opacity: 1,
                transition: 'visibility 0s, opacity 0.2s linear',
                ...style
            }}
        />}
    </React.Fragment>)
}


export default React.memo(Imgcomponent);